// Small shared helpers for the clubs pages.
/** Error value (string | Error | {message}) -> display string. */
export { msg } from "../../lib/errors";

/** Membership wins over verification (HomeScreen.js:933). */
export function joinStateFor(club, memberIds, pendingIds) {
  if (memberIds.has(club.id)) return "joined";
  if (!club.is_verified) return "inactive";
  return pendingIds.has(club.id) ? "applied" : "apply";
}

/** Only http(s) URLs may be opened from club content. Returns the href or null. */
export function safeHttpUrl(raw) {
  // Same as components/clubDetails/ClubAboutTab.js openLink.
  const url = String(raw ?? "");
  try {
    const parsed = new URL(url.startsWith("http") ? url : `https://${url}`);
    return parsed.protocol === "https:" || parsed.protocol === "http:" ? parsed.href : null;
  } catch {
    return null;
  }
}

/** Strictly-prefixed http(s) check used for documents (ClubAboutTab.openDocument). */
export const isHttpUrl = (u) => /^https?:\/\//i.test(String(u || "").trim());

export const displayUrl = (url) =>
  String(url || "").replace(/^https?:\/\//i, "").replace(/^www\./i, "").replace(/\/$/, "");
